import { regionInfo } from "../actions/types";

const initialState = {
  loading: false,
  info: null,
};

const regionReducer = (state = initialState, action) => {
  switch (action.type) {
    // REGION_INFO_READ
    case regionInfo.REGION_INFO_READ_REQUEST:
      return { ...state, loading: true };
    case regionInfo.REGION_INFO_READ_SUCCESS:
      return { ...state, loading: false, info: action.payload };
    case regionInfo.REGION_INFO_READ_FAIL:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default regionReducer;
